import { Klass, u_ } from "@pressmedia/webappbase";

export default {
	wysiwyg: {
		/**
		 * inpType: wysiwyg の項目のキー一覧を取得
		 * @param {Object} dataParams
		 * @returns {Array} params
		 */
		_getWysiwygParams(dataParams) {
			const params = [];
			u_.isObject(dataParams) && Object.keys(dataParams).forEach(pk => {
				const pi = dataParams[pk];
				if( u_.isObject(pi) && pi.inpType === "wysiwyg") {
					params.push(pk);
				}
			});
			return params;
		},
		
		/**
		 * Klass.VuwWysiwygFieldの読み込み
		 * @returns Proimse
		 */
		async _importKlass() {
			await import(/* webpackChunkName: "VuwWysiwygField" */ "@pressmedia/vuwwysiwygfield");
			return !!Klass("VuwWysiwygField");
		},
		
		/**
		 * wysiwyg用の設定を行う
		 * ※呼び出しの際は .call(this) を使用すること
		 * @returns Promise
		 */
		async ready() {
			if( !( this instanceof Klass("VuwJbForm") ) ) {
				throw new TypeError("caller must be VuwJbForm");
			}
			
			this.wysiwyg.params = this.wysiwyg._getWysiwygParams(this.config.dataParams);
			this.wysiwyg.params.has = !!this.wysiwyg.params.length;
			
			if( this.wysiwyg.params.has && !Klass("VuwWysiwygField") ) {
				this._promise = this.wysiwyg._importKlass();
			}
			
			return this._promise;
		}
	}
};
